import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as router from '@attain-apps/fe/web/main/lib/router'
import { capitalize } from '@attain-apps/string-utils'

import * as state from '../../../../../../../../state'

@ngCore.Component({
  imports: [
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    ds.button.Component,
    ds.input.text.Component,
  ],
  selector: 'atn-mosaic-page-setup-dialog',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.dev.pages.Collection} */
  public readonly pagesEc = ngCore.inject(state.mosaic.dev.pages.Collection)

  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)

  /** Alias of editing page */
  public readonly editingPageAliasSg = ngCore.computed(
    (
      page = this.pagesEc.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity()
        .asSignal(),
    ) => page?.alias?.trim(),
  )

  /** Name of editing page */
  public readonly editingPageNameSg = ngCore.computed(
    (
      page = this.pagesEc.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity()
        .asSignal(),
    ) => page?.name?.trim(),
  )

  /**  Indicates {@link getStartedButtonClickHandler} can be triggered */
  public readonly canGetStartedSg = ngCore.computed(
    (name = this.editingPageNameSg(), alias = this.editingPageAliasSg()) =>
      Boolean(name && alias),
  )

  /** Handles the click event by navigating to Mosaic Page Builder */
  public getStartedButtonClickHandler(): void {
    const url = this.meFeature.contexts.selectors
      .getUrlForLink({
        goto: {
          navigationId: ents.extra.prebuilt.AppPageAlias.PageBuilder,
        },
      })
      .asSignal()

    if (url) {
      this._router.actions.navigate
        .from('Dialog.GetStartedBtn.Clicked')
        .dispatch({ url })
    }
  }

  /**
   * Updates a specific property of the edited page.
   */
  public updatePageSetupInfo<K extends keyof ents.core.mosaic.Page.Input>(
    prop: K,
    value: ents.core.mosaic.Page.Input[K],
  ): void {
    this.pagesEc.plugins.editingPlugin.feature.actions.edit
      .from(`Dialog.${capitalize(prop)}.Inputted`)
      .dispatch({
        edit: page => {
          if (!page) {
            return
          }
          page[prop] = value
        },
      })
  }

  /** Discard changes handler */
  public cancelClickHandler(): void {
    this.pagesEc.plugins.editingPlugin.feature.actions.discard
      .from('Dialog.CancelBtn.Clicked')
      .dispatch({
        current: true,
      })
  }
}
